import FormDetailEdit from "./FormDetailEdit";
import FormDetail from "./FormDetail";
import { useOutletContext } from "react-router";
import { useEffect } from "react";

const TemplateGeneralInfo = () => {
  const {
    setBreadcrumbs,
    templateInfo,
    isEditing,
    formDetails,
    editedFormDetails,
    setEditedFormDetails,
    isNew,
    translate,
    locationSets,
    revisionSets,
    statusSets,
  } = useOutletContext();

  useEffect(() => {
    if (templateInfo || isNew) {
      setBreadcrumbs([
        {
          id: 0,
          title: "page_titles.form-templates",
          route: "auth.formTemplates",
        },
        {
          id: 1,
          customTitle:
            templateInfo?.name || translate("form_templates.new_form_template"),
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateInfo]);

  return (
    <>
      {isEditing ? (
        <FormDetailEdit
          formDetails={editedFormDetails}
          setFormDetails={setEditedFormDetails}
          isNew={isNew}
          translate={translate}
          locationSets={locationSets}
          revisionSets={revisionSets}
          statusSets={statusSets}
        />
      ) : (
        <FormDetail formDetails={formDetails} translate={translate} />
      )}
    </>
  );
};
export default TemplateGeneralInfo;
